const state = {
    data: {},
    keys:  {
        '0': 'Protocolo',
        '1': 'Data1',
        '2': 'Registro',
        '3': 'Nome',
        '4': 'Data', 
        '5': 'Idade',
        '6': 'CPF',
        '7': 'Convenio',
        '8': 'CEP',
        '9': 'Endereco',
        '10': 'EnderecoNum',
        '11': 'Cidade'
    }
}

const getters = {
    getDataTransduson(state) {
        return state.data;
    }
}

const actions = {}

const mutations = {
    async setDataTransduson(data) {
        // const arr = payload[0].replace("[", "").replace("]", "").split(',');
        // const res = {};
        // arr.forEach((el, index) => res[state.keys[index]] = el);
        // res['phone'] = payload[1];
        // res['type'] = 'phone';
        // state.data = res;
        let dataEvent = data.split('||');

       state.data = {
            queue: dataEvent[0],
            name: dataEvent[1],
            phone: dataEvent[1],
            type: 'phone'
       }
       return state.data;
    },

    async delDataTransduson() {
        state.data = {}
    },

    async setChatData(data){
        let obj = {Protocolo: data.protocol, phone: data.phone, type: 'chat', name: data.name, queue: data.queue};
        state.data = obj;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
